import { createSelector } from 'reselect'
import configurationDataSelector from './configurationDataSelector'

const hasConfigurationConflictSelector = createSelector(
    configurationDataSelector,
    (configurationData): boolean => configurationData.configurationState === 'CONFLICT',
)

export default hasConfigurationConflictSelector
